import React, { Component } from "react"
import { Helmet } from "react-helmet"
import { Box, Flex } from "grid-styled"

import { ImgScaled, H1, H2, H4, P, Page } from "../styled-components"

import bilder from "../bilder/impressum"

class Impressum extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Fotografie Anders: Impressum</title>
        </Helmet>
        <Flex flexDirection="column" alignItems="center">
          <ImgScaled
            data-sizes="100vw"
            srcSet={bilder[1].min}
            // src={bilder[1].max}
            data-srcset={bilder[1].srcset}
            className="lazyload blur-up"
            alt="Bild 01"
            width="100%"
          />
        </Flex>
        <Page>
          <H1>Impressum</H1>

          <Flex flexWrap="wrap">
            <Box width={[1, 1 / 2]}>
              <H2>Verantwortlich</H2>
              <p>
                FOTOGRAFIE ANDERS<br />
                Stephan Anders<br />
                50933 Köln
              </p>
            </Box>
            <Box width={[1, 1 / 2]}>
              <H2>Webdesign</H2>
              <p>
                <a href="http://webseiten-anders.de">webseiten anders</a>
              </p>
            </Box>
          </Flex>

          <H2>Rechtliches</H2>

          <H4>Inhalt des Onlineangebotes</H4>

          <P>
            Die Autoren übernehmen keinerlei Gewähr für die Aktualität,
            Korrektheit, Vollständigkeit oder Qualität der bereitgestellten
            Informationen. Haftungsansprüche gegen die Autoren, welche sich auf
            Schäden materieller oder ideeller Art beziehen, die durch die
            Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch
            die Nutzung fehlerhafter und unvollständiger Informationen
            verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens
            der Autoren kein nachweislich vorsätzliches oder grob fahrlässiges
            Verschulden vorliegt.
          </P>

          <P>
            Alle Angebote sind freibleibend und unverbindlich. Die Autoren
            behalten es sich ausdrücklich vor, Teile der Seiten oder das gesamte
            Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu
            löschen oder die Veröffentlichung zeitweise oder endgültig
            einzustellen.
          </P>

          <H4>Verweise und Links</H4>

          <P>
            Bei direkten oder indirekten Verweisen auf fremde Webseiten
            ("Hyperlinks"), die außerhalb des Verantwortungsbereiches der
            Autoren liegen, würde eine Haftungsverpflichtung ausschließlich in
            dem Fall in Kraft treten, in dem die Autoren von den Inhalten
            Kenntnis haben und es ihnen technisch möglich und zumutbar wäre, die
            Nutzung im Falle rechtswidriger Inhalte zu verhindern.
          </P>

          <P>
            Die Autoren erklären hiermit ausdrücklich, dass zum Zeitpunkt der
            Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten
            erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die
            Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten
            haben die Autoren keinerlei Einfluss. Deshalb distanziert er sich
            hiermit ausdrücklich von allen Inhalten aller verlinkten
            /verknüpften Seiten, die nach der Linksetzung verändert wurden.
            Diese Feststellung gilt für alle innerhalb des eigenen
            Internetangebotes gesetzten Links und Verweise sowie für
            Fremdeinträge in von den Autoren eingerichteten Gästebüchern,
            Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen
            anderen Formen von Datenbanken, auf deren Inhalt externe
            Schreibzugriffe möglich sind. Für illegale, fehlerhafte oder
            unvollständige Inhalte und insbesondere für Schäden, die aus der
            Nutzung oder Nichtnutzung solcherart dargebotener Informationen
            entstehen, haftet allein der Anbieter der Seite, auf welche
            verwiesen wurde, nicht derjenige, der über Links auf die jeweilige
            Veröffentlichung lediglich verweist.
          </P>

          <H4>Urheber- und Kennzeichenrecht</H4>

          <P>
            Die Autoren sind bestrebt, in allen Publikationen die Urheberrechte
            der verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und
            Texte zu beachten, von ihne selbst erstellte Bilder, Grafiken,
            Tondokumente, Videosequenzen und Texte zu nutzen oder auf
            lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte
            zurückzugreifen.
          </P>

          <P>
            Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte
            geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den
            Bestimmungen des jeweils gültigen Kennzeichenrechts und den
            Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein
            aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass
            Markenzeichen nicht durch Rechte Dritter geschützt sind!
          </P>

          <P>
            Das Copyright für veröffentlichte, von den Autoren selbst erstellte
            Objekte bleiben allein bei den Autoren der Seiten. Eine
            Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente,
            Videosequenzen und Texte in anderen elektronischen oder gedruckten
            Publikationen ist ohne ausdrückliche Zustimmung der Autoren nicht
            gestattet.
          </P>

          <H4>Datenschutz</H4>
          <P>
            Die Nutzung unserer Seiten ist ohne eine Angabe von
            personenbezogenen Daten möglich. Für die Nutzung einzelner Services
            unserer Seite können sich hierfür abweichende Regelungen ergeben,
            die in diesem Falle nachstehend gesondert erläutert werden. Ihre
            personenbezogenen Daten (z.B. Name, Anschrift, E-Mail,
            Telefonnummer, u.ä.) werden von uns nur gemäß den Bestimmungen des
            deutschen Datenschutzrechts verarbeitet. Daten sind dann
            personenbezogen, wenn sie eindeutig einer bestimmten natürlichen
            Person zugeordnet werden können. Die rechtlichen Grundlagen des
            Datenschutzes finden Sie im Bundesdatenschutzgesetz (BDSG) und dem
            Telemediengesetz (TMG). Wir weisen darauf hin, dass die
            internetbasierte Datenübertragung Sicherheitslücken aufweist, ein
            lückenloser Schutz vor Zugriffen durch Dritte somit unmöglich ist.
          </P>
          <P>
            Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe
            persönlicher oder geschäftlicher Daten (Emailadressen, Namen,
            Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens
            des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme
            und Bezahlung aller angebotenen Dienste ist — soweit technisch
            möglich und zumutbar — auch ohne Angabe solcher Daten bzw. unter
            Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die
            Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben
            veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und
            Faxnummern sowie Emailadressen durch Dritte zur Übersendung von
            nicht ausdrücklich angeforderten Informationen ist nicht gestattet.
            Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails
            bei Verstößen gegen dieses Verbot sind ausdrücklich vorbehalten.
          </P>

          <H4>Rechtswirksamkeit dieses Haftungsausschlusses</H4>

          <P>
            Dieser Haftungsausschluss ist als Teil des Internetangebotes zu
            betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern
            Teile oder einzelne Formulierungen dieses Textes der geltenden
            Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen
            sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt
            und ihrer Gültigkeit davon unberührt.
          </P>
        </Page>
      </div>
    )
  }
}

export default Impressum



// WEBPACK FOOTER //
// ./src/pages/Impressum.js